/**
 * HPH Team Cards
 * 3D tilt + holographic shine on trading cards (.hph-tcard).
 * Pointer position drives CSS custom properties; all visuals are CSS.
 * Desktop pointer devices only. Respects prefers-reduced-motion.
 * Technique adapted from simeydotme/pokemon-cards-css.
 */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAX_TILT = 12; // degrees

  function bind(card) {
    if (card.dataset.hphTcardBound) return;
    card.dataset.hphTcardBound = '1';

    var rect = null;

    card.addEventListener('pointerenter', function () {
      rect = card.getBoundingClientRect();
      card.classList.add('is-active');
    });

    card.addEventListener('pointermove', function (e) {
      if (!rect) rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      x = Math.min(Math.max(x, 0), 1);
      y = Math.min(Math.max(y, 0), 1);

      card.style.setProperty('--ry', ((x - 0.5) * MAX_TILT).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * MAX_TILT).toFixed(2) + 'deg');
      card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      card.style.setProperty('--posx', (50 + (x - 0.5) * 80).toFixed(1) + '%');
      card.style.setProperty('--active', '1');
    });

    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-active');
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
      card.style.setProperty('--active', '0');
      rect = null;
    });
  }

  function init() {
    document.querySelectorAll('[data-hph-tcard]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
